module.exports = __webpack_public_path__ + "static/Group6001@2x-2f5093a4a0ee6b365a2354d10a3bf28b.png";